/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-empty-function */
/*
 * @Author: yuxinyu@leedarson.com
 * @Date: 2021-05-06 17:40:44
 * Copyright © Leedarson. All rights reserved.
 */
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

const MenuItem = memo(({ children, onClick, ...restProps }) => {
  const handleClick = useCallback(() => {
    onClick(restProps.value);
  }, [onClick, restProps.value]);

  return (
    <div className="dropdown-menu-item" onClick={handleClick} {...restProps}>
      {children}
    </div>
  );
});

MenuItem.defaultProps = {
  onClick: () => {},
};

MenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default MenuItem;
